export default __webpack_public_path__ + "static/media/Profile.e770b197.svg";